import { createContext, useMemo } from "react"

import { ORIGINALS_DOMAIN } from "@/config"

// eslint-disable-next-line react-refresh/only-export-components
export const DomainContext = createContext({
  isOriginals: false,
  port: "443",
})

export function DomainProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => {
    return {
      isOriginals: ORIGINALS_DOMAIN === window.location.hostname,
      port: window.location.port,
    }
  }, [])

  return <DomainContext.Provider value={value}>{children}</DomainContext.Provider>
}
